<div id="events" class="userLike-container ya-typography" (swiperight) = "SwiperNavigateBack()">
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="true">
    <h2 class="ya-header-title" langkey="phUserLike_Header"></h2>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <ng-container *ngIf=" userLikes && userLikes.length>0; then pageTemplate else emptyTemplate"></ng-container>
    <ng-template #pageTemplate>
      <ng-container *ngFor="let userLike of userLikes">
        <div class="ya-icon-button service-button" (click)="navigateTo(userLike.contentType)">
          <div class="icon-container">
            <div class="inline-icon" [inlineSVG]="setSVGIcon(userLike.contentType)"></div>
          </div>
          <div class="content-container">
            <h2 class="title">{{userLike.contentName}}</h2>
            <div class="text content-container--subfont"></div>
          </div>
        </div>
      </ng-container>
    </ng-template>
    <ng-template #emptyTemplate>
      <ya-emptypage emptyTitle="phEmpty_UserLike_Page_Title" emptyContent="phEmpty_UserLike_Page_Content"></ya-emptypage>
    </ng-template>
  </div>
</div>